/* src/app/pages/small-molecule/small-molecule.component.scss */
.center {
  width: 25%;
  margin: 10px auto;
}
.main-div {
  height: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
button {
  margin-right: 10px;
}
th {
  font-weight: bold;
  background-color: #E6E8EB;
}
table {
  width: 100%;
}
table thead th {
  color: white;
  font-size: 10pt;
  background-color: #3b5998;
}
.make-gold {
  background-color: #FAF6E2;
}
.make-red {
  background-color: #F0DDDD;
}
.make-green {
  background-color: #DEEED7;
}
li {
  margin-top: 5px;
  margin-left: 10px;
  padding: 2px;
}
.mat-fab {
  min-width: 100px;
  min-height: 75px;
}
.badge {
  float: right;
}
.content {
  padding: 5px;
}
.content > mat-card {
  width: 100px;
}
.nolist {
  list-style: none;
}
.example-margin {
  margin-left: 20%;
}
.example1-margin {
  margin-left: 16.5%;
}
.example2-margin {
  margin-left: 20.5%;
}
.example-headers-align {
  display: block;
  margin-top: 20px;
}
.badge {
  margin-left: auto;
}
.mat-expansion-panel {
  margin-bottom: 10px;
}
.mat-expansion-panel-header {
  margin-top: 10px;
}
.error-box {
  background-color: rgb(224, 52, 52);
  color: #fff;
}
.table-container {
  overflow-x: auto;
  max-width: 100%;
}
.custom-table {
  width: 100%;
}
.heading {
  margin: auto;
}
th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.icon-container {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}
.icon {
  flex: 0.5;
  margin-right: 2px;
}
/*# sourceMappingURL=small-molecule.component.css.map */
